import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import UserBadge from './UserBadge';
import styled from 'styled-components';
import {motion} from 'framer-motion';
import {makeStyles} from '@material-ui/core/styles';
import {useSelector} from 'react-redux';
import {selectActiveUser} from './dashboardSlice';
import {fontSize} from '../../mixins';

const StyledButton = styled(motion.button)`
  padding: 0;
  width: 58px;
  height: 58px;
  border: none;
  background-color: transparent;
  border-radius: 50%;
  box-shadow: 2px 4px 8px rgba(0, 0, 0, 0.08), 16px 16px 16px rgba(97, 119, 122, 0.08);
`

const StyledName = styled.span`
  display: block;
  width: 55px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  ${fontSize(12)};
  line-height: 21px;
  font-weight: 500;
  letter-spacing: -0.0376471px;
  color: #323232;
`

const FakeUserPin = ({index, user}) => {
    const activeUser = useSelector(selectActiveUser);
    const isUserActive = user.id === activeUser;


    const useStyles = makeStyles({
        avatar: {
            width: '58px',
            height: '58px',
            border: isUserActive ? '3px solid #00BFA5' : '3px solid transparent',
        }
    });

    const classes = useStyles();

    return (
        <StyledButton whileHover={{scale: 1.1}} whileTap={{scale: 0.9}} id='continue-button'>
            <UserBadge key={index} userID={user.id}
                       appStatus={user.appStatus}
                       isFakeUser={user.isFakeUser}
            >
                <Avatar alt={user.name} src={user.fakeAvatar || '../images/default-static-avatar.png'} className={classes.avatar}/>
            </UserBadge>
            <StyledName>{user.name}</StyledName>
        </StyledButton>
    )
};

export default FakeUserPin;